/**
 * Handles the state for the SMS Opt In Nudge Modal *
 */ export var MARKETING_SMS_OPT_IN_DISMISSED = 'MARKETING_SMS_OPT_IN_DISMISSED';
